import BarDeltaDefault from '../../lib/jin/svgchartlib/01_Charts/06_Bar_Delta/includes/primitives/Data'

export default BarDeltaDefault